import React,{useEffect,useState} from 'react';
import {Grid,Box,Typography,Button,Tooltip} from '@mui/material'
// import {ReactComponent as ManagerTeamVector} from '../../StaticData/Vectors/managerTeamVector.svg';
// import {ReactComponent as PersonelVector} from '../../StaticData/Vectors/personelVector.svg';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';
import PersonelVector from '@mui/icons-material/Groups';
import EditIcon from '@mui/icons-material/Edit';
import {IconButton} from '@mui/material';
import { useDeleteTeam } from '../../Hooks';
import { useSelector } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
// import DialogContent from '@mui/material/DialogContent';
// import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

const TeamCart = (props:any) => {
  const navigate=useNavigate();
  const userId=useSelector((state:any)=>state.loign.userInfo.userId);
  const tenantId=useSelector((state:any)=>state.meetings.profileTenantId);
//   setShowToastMessage={setShowToastMessage}
// setEditTeamState={setTeamAsyncOpState}
    let {item,setTeamId,setShowEditForm,setShowEditAccessForm,setShowToastMessage,setDeleteTeamState}:any=props;
    let{name,managerName,managerCount,coachName,adminName,personCount,chlidsTeamCount,activated,id,pictureBase64String}=item;
    const{mutate:deleteTeam,isError,isSuccess,data:deleteData}=useDeleteTeam()
    const[imgSrc,setImgSrc]=useState<any>(null);

    const goTeamDetails=()=>{
      navigate('/dashboard/companyManagment/teamDetails',{/*replace:true,*/state:{parentId:id}})
    }

         
    const handleClickOpen = () => {
      setOpen(true);
    };
  
    const handleClosee = () => {
      setOpen(false);
    };
    const initialDeleteTeam=()=>{
          let deleteBody={
      deletedId:id,
      userId:userId,
      tenantId:tenantId

  }
  deleteTeam(deleteBody)
  handleClosee();

    }

    const initialEditTeam=()=>{
      setShowEditForm(true)
      setTeamId(id)
    }
    const initialEditAccess=()=>{
      setShowEditAccessForm(true)
      setTeamId(id)
    }

    useEffect(() => {
      
      if (deleteData) {
        setShowToastMessage(true);
        setDeleteTeamState(deleteData?.data)
      }
    
    
    }, [isSuccess,deleteData])

    
    useEffect(() => {
    
      if (item) {
        setImgSrc(pictureBase64String)
      }
        }, [item])
        const [open, setOpen] = React.useState(false);
        const theme = useTheme();
        const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
         const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // برای بررسی موبایل بودن





  return (
    <Box
      width={isMobile ? '270px' : '340px'}  // در موبایل عرض کوچکتر می‌شود
      minHeight={isMobile ? '180px' : '205px'} // در موبایل ارتفاع کوچکتر می‌شود
      marginRight={1}
     borderRadius={3} 
 boxShadow={4}
    m={1}
    p={0.5}
    >
      
        <Grid container p={1} >
       <Grid item xs={12}   >
    <Box width={'100%'}  display={'flex'} justifyContent={'space-between'} >
      <Box>
      {/* <Typography  color={'#001733'} fontWeight={700}  fontSize={'15px'} >
            {
                name
            }
        </Typography> */}
        {
                  name.length > 65 ? <Tooltip  sx={{ fontSize: '1.5rem !important' }} title={name}>
              <Typography mt={1} textAlign={'left'}   variant='body1'sx={{ fontSize: '13px !important', fontWeight:'600',color: 'black',cursor:'pointer'}}   >{name.slice(0,65)}</Typography>
            </Tooltip> : <Typography mt={1} textAlign={'left'} sx={{ fontSize: '13px !important',fontWeight:'600', color: 'black',cursor:'pointer'}}    >
              {
                 name
              }

            </Typography>
       }
      </Box>
      <Box marginTop={'0.5'}>
      <Tooltip  title="ویرایش">
      <IconButton onClick={()=>{
            initialEditTeam()
        }}   >
        <EditIcon color='primary'   />
       </IconButton>
       </Tooltip>

            <Tooltip  title="حذف">
        <IconButton  onClick={handleClickOpen}>
            <DeleteIcon color='error'/>
        </IconButton>
        </Tooltip>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClosee}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title" fontWeight={600} fontSize={'17px'}>
        {"آیا از حذف تیم اطمینان دارید؟"}
        </DialogTitle>
        {/* <DialogContent>
        </DialogContent> */}
        <DialogActions>
          <Button autoFocus onClick={handleClosee}>
          <Typography  color={'red'}> انصراف</Typography> 
          </Button>
          <Button onClick={()=>{ initialDeleteTeam()}} autoFocus>
          <Typography  color={'#00387C'} > تایید</Typography> 
          </Button>
        </DialogActions>
      </Dialog>
      </Box>
    </Box>
       </Grid>

       <Grid item xs={12}   >
       <Box mr={1.5} p={0.5}  display={'flex'} alignItems={'center'} justifyContent={'start'}  >
       <Typography mr={1.5} px={0.5} fontWeight={600} fontSize={'13px'}>
      سرمربی:
       </Typography>
       {/* {
        adminName !== null && adminName !== ''?
        <Box  mx={0.5} >
        <img src={imgSrc} width={'23px'} style={{borderRadius:'50%'}} />
        </Box>:
        <></>
       } */}
       <Typography fontWeight={600} fontSize={'13px'}>
            {adminName}
       </Typography>
       
       </Box>
       </Grid>
       <Grid item xs={12}   >
       <Box mr={1.5} p={0.5}  display={'flex'} alignItems={'center'} justifyContent={'start'}  >
       <Typography mr={1.5} px={0.5} fontWeight={600} fontSize={'13px'}>
       مربی:
       </Typography>
       {/* {
        coachName !== null && coachName !== ''?
        <Box  mx={0.5} >
        <img src={imgSrc} width={'23px'} style={{borderRadius:'50%'}} />
        </Box>:
        <></>
       } */}
       <Typography fontWeight={600} fontSize={'13px'}>
            {coachName}        
       </Typography>
       
       </Box>
       </Grid>

       <Grid item xs={12}   >
       <Box mr={1.5} display={'flex'} alignItems={'center'} justifyContent={'start'}  >
       <Typography variant='body1' fontWeight={600} ml={1} fontSize={'13px'} >
       مدیر:
       </Typography>
       {
        managerName !== null && managerName !== ''?
        <Box  mx={0.5} >
        <img src={imgSrc} width={'23px'} style={{borderRadius:'50%'}} />
        </Box>:
        <></>
       }
       {
                  managerName.length > 35 ? <Tooltip  sx={{ fontSize: '1.5rem !important' }} title={managerName}>
              <Typography textAlign={'left'}   variant='body1'sx={{ fontSize: '13px !important', fontWeight:'600',color: 'black',cursor:'pointer'}}   >{managerName.slice(0,35)}</Typography>
            </Tooltip> : <Typography  textAlign={'left'} sx={{ fontSize: '13px !important',fontWeight:'600', color: 'black',cursor:'pointer'}}    >
              {
                 managerName
              }

            </Typography>
       }
       </Box>
       </Grid>

       <Grid item xs={12}  >
        <Box  display={'flex'} justifyContent={'start'} alignItems={'center'} >
   <Box px={1} >
    <PersonelVector fontSize='large'/> 
   </Box>
   <Box>
    <Typography  variant='caption' color={'black'} fontWeight={600} fontSize={'12px'}>
        {
            `${personCount} عضو و ${chlidsTeamCount} زیر گروه`
        }
    </Typography>
   </Box>
        </Box>
       </Grid>

       <Grid item xs={12}  >
       <Box width={'100%'} marginTop={1} display={'flex'} justifyContent={'space-between'} alignItems={'center'} >
        {/* <Box bgcolor={'#D5f7D4'} display={'flex'} justifyContent={'center'} alignItems={'center'} width={'80px'} height={'28px'} borderRadius={3}>
     <Typography fontSize={'0.80rem'} fontWeight={activated?900:400} color={activated?'green':'red'}>
        {
            activated?'فعال':'غیرفعال'
        }
     </Typography>
        </Box>
        <Box width={'110px'} height={'30px'}  bgcolor={'#dbdad5'} borderRadius={3} display={'flex'} justifyContent={'center'}>
        <Button variant='text' onClick={initialEditAccess}  >
          <Typography  fontSize={'0.8rem'} color={'#636361'} >  سطوح دسترسی
          </Typography>
        </Button>
        
      </Box>  */}
            <Box bgcolor={'#D5f7D4'} display={'flex'} justifyContent={'center'} alignItems={'center'} width={'80px'} height={'28px'} borderRadius={3}>
        <Typography
          fontSize={isMobile ? '0.65rem' : '0.80rem'} // تغییر اندازه فونت برای موبایل
          fontWeight={activated ? 900 : 400}
          color={activated ? 'green' : 'red'}
        >
          {activated ? 'فعال' : 'غیرفعال'}
        </Typography>
      </Box>

      <Box width={'110px'} height={'30px'} bgcolor={'#dbdad5'} borderRadius={3} display={'flex'} justifyContent={'center'}>
        <Button variant='text' onClick={initialEditAccess}>
          <Typography fontSize={isMobile ? '0.65rem' : '0.8rem'} color={'#636361'}>
            سطوح دسترسی
          </Typography>
        </Button>
      </Box>
      {/* <Box py={1} display={'flex'} justifyContent={'end'} bgcolor={'#c5d3de'} width={'100px'} height={'30px'} borderRadius={3} padding={0} >
        <Button variant='text' onClick={goTeamDetails} >
        مشاهده جزئیات
        </Button>
      </Box> */}
      <Box
  py={1}
  display={'flex'}
  justifyContent={'end'}
  bgcolor={'#c5d3de'}
  width={'100px'}
  height={'30px'}
  borderRadius={3}
  padding={0}
>
  <Button
    variant='text'
    onClick={goTeamDetails}
    sx={{
      // fontSize: '14px', // فونت پیش‌فرض برای دسکتاپ
      '@media (max-width: 600px)': {
        fontSize: '10px', // فونت برای موبایل کوچکتر می‌شود
      }
      ,
    }}
  >
    مشاهده جزئیات
  </Button>
</Box>

       </Box>
       </Grid>
        </Grid>


    </Box>
  )
}

export default TeamCart